<header>
  <div class="app-title" routerLink="/">IntelliJ-RON Plugin</div>

  <button vx-button="stroked" color="light" variation="flat" [vxMenuTrigger]="menu">
    <fa-icon icon="bars" size="lg"></fa-icon>
  </button>

  <vx-menu #menu>
      <vx-item *ngFor="let route of routes" [routerLink]="route.route" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
               (select)="router.navigateByUrl(route.route)">
        {{route.name}}
      </vx-item>
  </vx-menu>
</header>

<div class="pageBody">
  <router-outlet></router-outlet>
</div>
